import * as React from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Row,
  Col
} from "reactstrap";
import { connect } from "react-redux";
import Header from "./Header";
import { RootState } from "../../store";
import {
  setConsent,
    sendApplication,
    gotoStep

} from "../../store/application/applicationActions";
import { FormStep, Step } from "../../store/application/applicationState";
import { AseApi, AlmBrandApi, } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";
import ApplicationContent from "../applicationContent";
import SimpleModal from "./SimpleModal";
import ApplicationFooter from "../applicationFooter";
import { type } from "os";

interface StepConsentState {
  dirty: boolean;
    termsOfService: boolean;
    aseConsent: boolean;
    almBrandConsent: boolean;
    name: string;
    email: string;
    mobile: string;
    address: string;
    postalcode: string;
    city: string;
    id: string;
  creditCheck: {
    accepted: boolean;
    modalIsOpen: boolean;
  };
  eSkatConsent: {
    accepted: boolean;
    modalIsOpen: boolean;
  };
  insurance: {
    shown: boolean;
    accepted: boolean;
    modalIsOpen: boolean;
  };
  marketing: {
    accepted: boolean;
    modalIsOpen: boolean;
    };
    
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class StepConsent extends React.Component<Props, StepConsentState> {
  shouldShowInsuranceOffer(cpr: string): boolean {
    //0707614293
    const now = new Date();

    const birthDate = new Date(
      parseInt(cpr.substring(4, 6)),
      parseInt(cpr.substring(2, 4)) - 1,
      parseInt(cpr.substring(0, 2))
    );

    const cutoffDate = new Date(
      now.getFullYear() - 18 - 100,
      now.getMonth(),
      now.getDate()
    );

    if (birthDate.getTime() < cutoffDate.getTime()) {
      birthDate.setFullYear(birthDate.getFullYear() + 100);
    }

    return now.getFullYear() - birthDate.getFullYear() < 60;
  }

  constructor(props: Props) {
    super(props);

    this.state = {
      dirty: false,
        termsOfService: props.application.data.termsOfService,
        aseConsent: props.application.data.aseConsent,
        almBrandConsent: props.application.data.almBrandConsent,
        name: props.application.data.name,
        email: props.application.data.email,
        mobile: props.application.data.mobile,
        address: props.application.data.address,
        postalcode: props.application.data.postalcode,
        city: props.application.data.city,
        id: props.application.application.id,

      creditCheck: {
        accepted: props.application.data.creditCheck,
        modalIsOpen: false
      },
      eSkatConsent: {
        accepted: props.application.data.eSkatConsent,
        modalIsOpen: false
      },
      insurance: {
        shown: this.shouldShowInsuranceOffer(props.application.data.cpr),
        accepted: props.application.data.insurance,
        modalIsOpen: false
      },
      marketing: {
        accepted: props.application.data.marketing,
        modalIsOpen: false
        }
    };

    this.next = this.next.bind(this);
  }

  next(): void {
    this.setState({ dirty: true });

    if (
      this.state.termsOfService &&
      this.state.creditCheck &&
      this.state.eSkatConsent.accepted &&
      this.state.marketing.accepted
    ) {
      this.props.setConsent(
        this.state.termsOfService,
        this.state.creditCheck.accepted,
        this.state.eSkatConsent.accepted,
        this.state.insurance.accepted,
        this.state.marketing.accepted
        );
        //console.log("Dette er AlmBrand Consent", this.state.almBrandConsent)
        //console.log("Dette er Ase Consent", this.state.aseConsent)
        //if (this.state.almBrandConsent == true) {
        //    const almBrandApi = new AlmBrandApi(apiConfiguration);
        //    const fullName = this.state.name.split(" ");
        //    try {
        //        const AlmBrand = almBrandApi.apiAlmBrandSendInfoPost({
        //            firstName: fullName[0],
        //            lastName: fullName[fullName.length - 1],
        //            email: this.state.email,
        //            phone: this.state.mobile.toString(),
        //            address: this.state.address,
        //            postalcode: this.state.postalcode,
        //            city: this.state.city,
        //            id: JSON.parse(this.state.id),
        //        })
        //    } catch (e) {
        //    }
        //}
        if (this.state.aseConsent == true) {
            const aseApi = new AseApi(apiConfiguration);
            const fullName = this.state.name.split(" ");
            try {
                const Ase = aseApi.apiAseSendInfoPost({
                    firstName: fullName[0],
                    lastName: fullName[fullName.length - 1],
                    email: this.state.email,
                    phone: this.state.mobile.toString(),
                    address: this.state.address,
                    postalcode: this.state.postalcode,
                    city: this.state.city,
                    id: JSON.parse(this.state.id),
                })
            } catch (e) {
            }
        }
        this.props.sendApplication();
    }
  }

    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "12");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
    return (
      <div>
            <Header formStep={FormStep.Payment} step={Step.Payment} />
        <ApplicationContent>
                </ApplicationContent>

      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: any) => void) => ({
    previous: () => dispatch(gotoStep(Step.Payment)),
  setConsent: (
    termsOfService: boolean,
    creditCheck: boolean,
    eSkat: boolean,
    insurance: boolean,
      marketing: boolean
  ) =>
    dispatch(
        setConsent(termsOfService, creditCheck, eSkat, insurance, marketing)
    ),
  sendApplication: () => dispatch(sendApplication())
});

export default connect(mapStateToProps, mapDispatchToProps)(StepConsent);
